import { ThHTMLAttributes } from "react";

import { StickyTableHead } from "@/components/_atoms/table";
import { cn } from "@/lib/cn";

export function MunicipalPropertyTableHead({ className, ...props }: ThHTMLAttributes<HTMLTableCellElement>) {
  return (
    <StickyTableHead
      className={cn(
        "whitespace-nowrap bg-background shadow-[inset_0_-1px_0_0_var(--color-border)] px-3 text-xs font-normal first:pl-[var(--chrome-gutter)] last:pr-[var(--chrome-gutter)]",
        className,
      )}
      {...props}
    />
  );
}
